import {
  SectionContainer,
  Slider,
  SliderSlide
} from "@silversea-ssc/ui-components-react";
import React, { useCallback, useState } from "react";
import { ExpeditionTeamMemberFragment } from "types/graphql-types";
import ExpeditionTeamMemberCard from "components/ExpeditionTeamMember/ExpeditionTeamMemberCard";
const ExpeditionTeamMemberModal = React.lazy(
  () => import("components/ExpeditionTeamMember/ExpeditionTeamMemberModal")
);

type Props = {
  expeditionTeam: ExpeditionTeamMemberFragment[];
  id: string;
};

const ExpeditionTeamSlider: React.FC<React.PropsWithChildren<Props>> = ({
  expeditionTeam,
  id,
  children
}) => {
  const [openExpeditionTeamMember, setOpenExpeditionTeamMember] = useState<
    ExpeditionTeamMemberFragment | undefined
  >(undefined);

  return (
    <React.Fragment>
      <SectionContainer
        dataContentName="expedition_team"
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor="neutral05"
        id={id}
      >
        {children}
        <Slider variantColor="white" variant="compact">
          {expeditionTeam.map((team) => {
            return (
              <ExpeditionTeamSlide
                key={team._id}
                team={team}
                onClick={setOpenExpeditionTeamMember}
              />
            );
          })}
        </Slider>
      </SectionContainer>
      {openExpeditionTeamMember && (
        <React.Suspense fallback={<div></div>}>
          <ExpeditionTeamMemberModal
            modal={{
              isOpen: !!openExpeditionTeamMember,
              onRequestClose: () => setOpenExpeditionTeamMember(undefined)
            }}
            member={openExpeditionTeamMember}
          />
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

const ExpeditionTeamSlide: React.FC<ExpeditionTeamSliderProps> = ({
  team,
  onClick
}) => {
  const _onClick = useCallback(() => {
    onClick(team);
  }, [onClick, team]);

  return (
    <SliderSlide key={team._id}>
      <ExpeditionTeamMemberCard
        cardBackgroundColor="white"
        name={team.name}
        title={team.title?.localized}
        picture={team.picture}
        onClick={_onClick}
      />
    </SliderSlide>
  );
};

type ExpeditionTeamSliderProps = {
  team: ExpeditionTeamMemberFragment;
  onClick: (team: ExpeditionTeamMemberFragment) => void;
};

export default ExpeditionTeamSlider;
